import fireboltBlueberry from '@iq-firebolt/blueberry-theme'
import CompletaryDataForm from './CompletaryDataForm'

import useComplementaryData from './hook'

const ComplementaryData = ({
  fireboltStep,
  customGoBack,
}) => {
  const {
    handleGoBackform,
    runBeforeChangeStep,
    isOpenModal,
    closeModal,
    autofill,
  } = useComplementaryData({ fireboltStep, customGoBack })

  const isOpen = isOpenModal

  return (
    <>
      <CompletaryDataForm
        autofill={autofill}
        schema={fireboltStep?.fields}
        onSubmit={fireboltStep?.goNextStep}
        remoteErrors={fireboltStep?.validationErrors}
        theme={fireboltBlueberry}
        onGoBack={handleGoBackform}
        beforeSubmitStep={runBeforeChangeStep}
        isOpen={isOpen}
        actionButton={closeModal}
      />
    </>
  )
}

export default ComplementaryData
